import { ThemeColors } from "/@src/helpers/ThemeColors";

const colors = ThemeColors();

export const timeOfDayData = {
  labels: Array.from({ length: 40 }, (_, i) => i + 1),
  datasets: [
    {
      label: "",
      borderColor: colors.themeColor1,
      backgroundColor: colors.themeColor1_10,
      // randomly generated N = 40 length array 0 <= A[N] <= 39
      data: Array.from({ length: 40 }, () => Math.floor(Math.random() * 40)),
      // data: [456, 479, 324, 569, 702, 600],
      borderWidth: 2,
    },
    //   {
    //     label: 'Desserts',
    //     borderColor: colors.themeColor2,
    //     backgroundColor: colors.themeColor2_10,
    //     data: [364, 504, 605, 400, 345, 320],
    //     borderWidth: 2,
    //   },
  ],
};

export const browsersData = {
  labels: ["Chrome", "Firefox", "Safari", "Others"],
  datasets: [
    {
      label: "",
      borderColor: colors.themeColor1,
      backgroundColor: colors.themeColor1_10,
      // data: [10, 4, 25, 1],
      data: Array.from({ length: 4 }, () => Math.floor(Math.random() * 25)),
      borderWidth: 2,
    },
  ],
};

export const buildMainGraphData = ({labels, plot}) => ({
  labels: labels,
  datasets: [
    {
      label: "",
      // data: [54, 63, 60, 65, 60, 68, 60],
      // data: Array.from({ length: 7 }, () => Math.floor(Math.random() * 25)),
      data: plot,
      borderColor: colors.themeColor1,
      pointBackgroundColor: colors.foregroundColor,
      pointBorderColor: colors.themeColor1,
      pointHoverBackgroundColor: colors.themeColor1,
      pointHoverBorderColor: colors.foregroundColor,
      pointRadius: 4,
      pointBorderWidth: 2,
      pointHoverRadius: 5,
      fill: true,
      borderWidth: 2,
      backgroundColor: colors.themeColor1_10,
    },
  ],
});

export const usersGraphData = {
  labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  datasets: [
    {
      label: "",
      // data: [54, 63, 60, 65, 60, 68, 60],
      data: Array.from({ length: 7 }, () => Math.floor(Math.random() * 25)),
      borderColor: colors.themeColor1,
      pointBackgroundColor: colors.foregroundColor,
      pointBorderColor: colors.themeColor1,
      pointHoverBackgroundColor: colors.themeColor1,
      pointHoverBorderColor: colors.foregroundColor,
      pointRadius: 4,
      pointBorderWidth: 2,
      pointHoverRadius: 5,
      fill: true,
      borderWidth: 2,
      backgroundColor: colors.themeColor1_10,
    },
  ],
};

export const projectList = [
  {
    id: "1",
    value: "P1",
    name: "Project 1",
    date: "2022-04-01",
    category: "Category 1",
    users: 6,
    views: 34,
    avgViewDuration: "00.01.53",
    percentNewViews: 17.65,
    usersGraphData: {
      ...usersGraphData,
      datasets: [
        {
          ...usersGraphData.datasets[0],
          data: Array.from({ length: 7 }, () => Math.floor(Math.random() * 25)),
        },
      ],
    },
    browsersData: {
      ...browsersData,
      datasets: [
        {
          ...browsersData.datasets[0],
          data: Array.from({ length: 4 }, () => Math.floor(Math.random() * 25)),
        },
      ],
    },
    timeOfDayData: {
      ...timeOfDayData,
      datasets: [
        {
          ...timeOfDayData.datasets[0],
          data: Array.from({ length: 40 }, () =>
            Math.floor(Math.random() * 40)
          ),
        },
      ],
    },
    markers: [
      { markerOffset: 25, name: "Bogota", coordinates: [-74.0721, 4.711] },
      { markerOffset: 25, name: "Quito", coordinates: [-78.4678, -0.1807] },
      {
        markerOffset: -15,
        name: "Georgetown",
        coordinates: [-58.1551, 6.8013],
      },
      {
        markerOffset: -15,
        name: "Asuncion",
        coordinates: [-57.5759, -25.2637],
      },
      { markerOffset: 25, name: "Paramaribo", coordinates: [-55.2038, 5.852] },
    ],
  },
  {
    id: "2",
    value: "P2",
    name: "Project 2",
    date: "2022-05-07",
    category: "Category 2",
    users: 67,
    views: 56,
    avgViewDuration: "00.00.53",
    percentNewViews: 50.54,
    usersGraphData: {
      ...usersGraphData,
      datasets: [
        {
          ...usersGraphData.datasets[0],
          data: Array.from({ length: 7 }, () => Math.floor(Math.random() * 25)),
        },
      ],
    },
    browsersData: {
      ...browsersData,
      datasets: [
        {
          ...browsersData.datasets[0],
          data: Array.from({ length: 4 }, () => Math.floor(Math.random() * 25)),
        },
      ],
    },
    timeOfDayData: {
      ...timeOfDayData,
      datasets: [
        {
          ...timeOfDayData.datasets[0],
          data: Array.from({ length: 40 }, () =>
            Math.floor(Math.random() * 40)
          ),
        },
      ],
    },
    markers: [
      {
        markerOffset: -15,
        name: "Buenos Aires",
        coordinates: [-58.3816, -34.6037],
      },
      { markerOffset: -15, name: "La Paz", coordinates: [-68.1193, -16.4897] },
      { markerOffset: 25, name: "Brasilia", coordinates: [-47.8825, -15.7942] },
      { markerOffset: 25, name: "Santiago", coordinates: [-70.6693, -33.4489] },
    ],
  },
  {
    id: "3",
    value: "P3",
    name: "Project 3",
    date: "2022-04-01",
    category: "Category 3",
    users: 20,
    views: 43,
    avgViewDuration: "00.08.53",
    percentNewViews: 39.87,
    usersGraphData: {
      ...usersGraphData,
      datasets: [
        {
          ...usersGraphData.datasets[0],
          data: Array.from({ length: 7 }, () => Math.floor(Math.random() * 25)),
        },
      ],
    },
    browsersData: {
      ...browsersData,
      datasets: [
        {
          ...browsersData.datasets[0],
          data: Array.from({ length: 4 }, () => Math.floor(Math.random() * 25)),
        },
      ],
    },
    timeOfDayData: {
      ...timeOfDayData,
      datasets: [
        {
          ...timeOfDayData.datasets[0],
          data: Array.from({ length: 40 }, () =>
            Math.floor(Math.random() * 40)
          ),
        },
      ],
    },
    markers: [
      {
        markerOffset: 25,
        name: "Montevideo",
        coordinates: [-56.1645, -34.9011],
      },
      { markerOffset: -15, name: "Caracas", coordinates: [-66.9036, 10.4806] },
      { markerOffset: -15, name: "Lima", coordinates: [-77.0428, -12.0464] },
    ],
  },
  {
    id: "4",
    value: "P4",
    name: "Project 4",
    date: "2022-04-01",
    category: "Category 4",
    users: 15,
    views: 14,
    avgViewDuration: "00.04.53",
    percentNewViews: 20.65,
    usersGraphData: {
      ...usersGraphData,
      datasets: [
        {
          ...usersGraphData.datasets[0],
          data: Array.from({ length: 7 }, () => Math.floor(Math.random() * 25)),
        },
      ],
    },
    browsersData: {
      ...browsersData,
      datasets: [
        {
          ...browsersData.datasets[0],
          data: Array.from({ length: 4 }, () => Math.floor(Math.random() * 25)),
        },
      ],
    },
    timeOfDayData: {
      ...timeOfDayData,
      datasets: [
        {
          ...timeOfDayData.datasets[0],
          data: Array.from({ length: 40 }, () =>
            Math.floor(Math.random() * 40)
          ),
        },
      ],
    },
    markers: [
      { markerOffset: 25, name: "Quito", coordinates: [-78.4678, -0.1807] },
      {
        markerOffset: -15,
        name: "Georgetown",
        coordinates: [-58.1551, 6.8013],
      },
    ],
  },
];
